<template>
    <div class="page">
        <Nav defaultPath="/businessCooperation"></Nav>
        <div class="banner">
            <div class="msgBox">
                <div class="txt1">{{ $t('bannerTxt.title2') }}</div>
                <div class="txt2">{{ $t('bannerTxt.msg2') }}</div>
            </div>
            <img src="https://4d-ai.chat/img/banner5.png"></img>
        </div>
        <div class="main needVisible">
            <div class="item">
                <img src="https://4d-ai.chat/img/icon1.png">
                <p>{{ $t('contactUs.content12') }}：18958077780{{ $t('contactUs.content15') }}</p>
            </div>
            <div class="item">
                <img src="https://4d-ai.chat/img/icon2.png">
                <p>{{ $t('contactUs.content13') }}：zhexinsiwei@4d-ai.chat</p>
            </div>
            <div class="item">
                <img src="https://4d-ai.chat/img/icon3.png">
                <p>{{ $t('contactUs.content11') }}：{{ $t('contactUs.content14') }}</p>
            </div>
        </div>
        <ContactUs></ContactUs>
        <div class="totop" @click.stop="toTop()" v-if="showGoTop">
            <img src="https://4d-ai.chat/img/totop.png">
        </div>
    </div>
</template>
<script>
import Nav from '@/components/Nav.vue';
import ContactUs from '@/components/ContactUs.vue';
export default {
    components: {
        Nav,
        ContactUs
    },
    data() {
        return {
            showGoTop: false,
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll, true);
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                } else {
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });
        const boxes = document.querySelectorAll('.needVisible');
        boxes.forEach(box => {
            observer.observe(box);
        });
    },
    methods: {
        handleScroll() {
            let scrolltop = document.documentElement.scrollTop;
            if (scrolltop > window.innerHeight) {
                this.showGoTop = true
            } else {
                this.showGoTop = false
            }
        },
        toTop() {
            document.documentElement.scrollTop = 0;
        },
    }
}
</script>
<style scoped lang="less">
@media (max-width: 768px) {
    .main {
        padding: 10px !important;
    }

    .page {
        padding: 40px 0 0 !important;
    }

    .txt1 {
        font-size: 20px !important;
    }

    .txt2 {
        font-size: 12px !important;
    }

    .msgBox {
        width: 100% !important;
    }

    .item {
        margin-bottom: 10px !important;

        img {
            width: 50px !important;
        }
    }

    p {
        font-size: 14px !important;
    }
}
</style>
<style scoped lang="less">
.page {
    box-sizing: border-box;
    padding: 64px 0 0;

    .needVisible {
        opacity: 0;
        transform: translateY(20px);
        transition: all 1s ease-out;
    }

    .visible {
        opacity: 1;
        transform: translateY(0);
    }

    .totop:hover {
        background: #2743af;
    }

    .totop {
        width: 48px;
        height: 56px;
        background-color: #243c8a;
        position: fixed;
        z-index: 20;
        right: 30px;
        bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        cursor: pointer;

        img {
            width: 45%;
        }
    }

    .main {
        background-color: #f9fafb;
        padding: 80px 402px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap: 40px;

        .item {
            padding: 20px;
            box-shadow: 0 2px 8px #0000001a;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;

            p {
                font-size: 24px;
                color: #4d5563;
            }

            img {
                width: 50px;
            }
        }
    }

    .banner {
        width: 100%;
        display: flex;
        position: relative;

        .msgBox {
            position: absolute;
            text-align: center;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;

            .txt1 {
                font-size: 60px;
                font-weight: 600;
            }

            .txt2 {
                font-size: 25px;
            }
        }

        img {
            width: 100%;
            top: 0;
            left: 0;
        }
    }
}
</style>